import * as React from "react";
import { navigate } from "gatsby";
import { Text } from "@uikit";
import LoginSignUp from "@components/navbar/loginSignup";
import { useAuth } from "@store/auth";
import { useApp } from "@store/app";

const TopBar = () => {
  const userToken = useAuth(($) => $.userToken);
  const setShowFindBookingModal = useApp(($) => $.setShowFindBookingModal);
  const [showLoginModal, setShowLoginModal] = React.useState(false);
  const navigation = React.useMemo(() => {
    return [
      {
        name: "About Us",
        onClick: () => {
          navigate("/about-us");
        },
      },
      {
        name: "Our Reviews",
        onClick: () => {
          navigate("/reviews");
        },
      },
      {
        name: `Manage Your Booking`,
        onClick: () => {
          if (userToken) {
            navigate("/account/bookings");
          } else {
            setShowFindBookingModal();
          }
        },
      },
    ];
  }, [userToken]);

  return (
    <>
      <nav className="bg-green justify-center hidden sm:flex h-[34px]">
        <div className="lg:max-w-[1000px] xl:max-w-[1120px] mx-auto px-[20px] md:px-10 lg:px-0 flex flex-1 justify-end  items-center">
          <div className="flex align-middle justify-end gap-[40px]">
            {navigation.map((item, index) => (
              <div
                onClick={() => {
                  item.onClick();
                }}
                className="cursor-pointer    py-[3px] flex self-start"
                key={index}
              >
                <Text
                  size={13}
                  leading={1.3}
                  weight="semibold"
                  color="white"
                  className="hover:underline"
                >
                  {item.name}
                </Text>
              </div>
            ))}
          </div>
        </div>
      </nav>

      <LoginSignUp
        visible={showLoginModal}
        defaultMode="manage"
        onClose={() => {
          setShowLoginModal(false);
        }}
        onSignIn={() => {
          setShowLoginModal(false);
        }}
      />
    </>
  );
};
export default TopBar;
